import { RouterProvider } from "react-router-dom";
import { appRouter } from "@/core/router/appRouter.tsx";
import { TitleProvider } from "@/core/context/TitleContext.tsx";

function App() {

    return (
        <TitleProvider>
            <RouterProvider router={appRouter} />
        </TitleProvider>
    );
}

export default App;
